export default __webpack_public_path__ + "static/media/logokastafiore.2a965782.svg";